import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoSideNav from '../images/logo.png';
import { CiHome } from "react-icons/ci";

import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
function Nav({ darw: propDarw, setDarw: propSetDarw }) {
  const [binventory, setBinventory] = useState(false);
  // Always initialize state using props or default
  const [darwState, setDarwState] = useState(propDarw ?? true);

  // Use the provided setDarw or fallback to internal state
  const darw = propDarw ?? darwState;
  const setDarw = propSetDarw ?? setDarwState;
  const [userLogin, setUser] = useState([]);
  const [userType, setUserType] = useState('');
  const [mediaBreakPoint, setMediaBreakPoint] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const panel = localStorage.getItem("panel");
  
  const [uid, setUid] = useState('');



  const [nav, setNav] = useState([{
    ewallet: false, binventory: false, subscription: false, product: false, catalog: false,
    warehouse: false, khata: false, manageleads: false, mattersheet: false, logistics: false,
    logistics_driver: false, newbusiness: false, ad: false, office: false, darw: false
  }]);

  const navigate = useNavigate();


  const changeNavList = (i, changes) => {
    const a = 0;
    const oldArr = [...nav];
    const oldOb = oldArr[a];
    oldArr[a] = { ...oldOb, ...changes };
    localStorage.setItem("nav", JSON.stringify(oldArr))
    setNav(oldArr);
  }

  // useEffect hook to check the window's width on component mount and resize
  useEffect(() => {
    // Function to check the window's width
    const handleResize = () => {
      if (window.innerWidth <= 935) {
        setDarw(false);
        setMediaBreakPoint(true); // Set to true if the width is less than or equal to 935px
      } else {
        setDarw(true);// Set to false if the width is greater than 935px
        setMediaBreakPoint(false);
      }
    };

    // Call handleResize on initial render
    handleResize();

    // Add event listener to window resize event
    window.addEventListener('resize', handleResize);

    // Clean up event listener when component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const as = JSON.parse(localStorage.getItem("nav"))
    if (as == null) {
      localStorage.setItem("nav", JSON.stringify(nav))

    } else {
      setNav(as)
    }

    const v = JSON.parse(localStorage.getItem("USER"));


    if (v === null) {
      navigate("/login");
    }
    else {
      setUser(v);
      console.log("")
      setUserType(v[0].roll)
      setUid(v[0].id);
    }
  }, []);
  return (
    <>
      {darw ? (
        <>
          {" "}
          <div className="sidebar sidebar-hide-to-small sidebar-shrink sidebar-gestures" style={{ height: '100vh', overflow: 'hidden' }}>
            <div className="nano" style={{ height: '100%' }}>
              <div className="nano-content">

              <div
          onClick={() => {
            setDarw(!darw);
          }}
          style={{
            border: '1px solid rgb(79, 151, 161)',
            height: '40px',
            borderRadius: '50%',
            width: '37px',
            background: 'rgb(79, 151, 161)',
            zIndex: 999,
            display: 'none'
          }}
          className="hamburger-parent pull-right my-2"
        >
          <div
            className="hamburger"
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>


                <div className="logo mt-3">
                  <span>
                    <img
                      onClick={() => {
                        navigate("/");
                      }}
                      width="150px"
                      src={LogoSideNav}
                      alt=""
                    />
                  </span>
                </div>
                <SimpleBar
                  style={{
                    height: "calc(100vh - 130px)", // Correctly subtract space for the header/logo
                    overflowY: "auto",
                    padding: "0 5px",
                    marginTop: 20,
                  }}
                >
                  <ul>
                {/* <li
                      onClick={() => {
                        navigate("/");
                      }}
                      className="my-3 mx-3"
                    >
                      <span className="sidebar-sub-toggle">
                        <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="#fff"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z" /></svg>

                        <span className="font-size-14">Main Website</span>{" "}
                        </span>
                    </li> */}

                    <li
                      onClick={() => {
                        navigate("/");
                      }}
                      className=""
                    >
                      {/* <span className="sidebar-sub-toggle" style={ location.pathname === '/buyer' && { backgroundColor: 'rgba(69, 174, 180, 0.8)' }} > */}
                      <span className="sidebar-sub-toggle">
                        <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z" /></svg>

                        <span className="font-size-14">Main Website</span>{" "}
                      </span>
                      {/* </span> */}
                    </li>

                    
                    {/* <a
                    href="/"
                  >
                    <li style={{ color: "white", cursor: "pointer" }} className=" my-3 mx-3">
                      <span className="sidebar-sub-toggle">
                        <i className="ti-home"></i> 
                      </span>
                    </li>
                  </a> */}
                    {/* <a
                    href="/seller"
                  >
                    <li
                      style={{ color: "white", cursor: "pointer" }}
                      className=" my-3 mx-3"
                    >
                      <span className="sidebar-sub-toggle">
                        <i className="fa fa-window-restore" aria-hidden="true"></i> Dashboard
                      </span>
                    </li>
                  </a> */}

                    <li
                      onClick={() => {
                        navigate(panel === 'seller' ? '/seller' : '/buyer');
                      }}
                      className=""
                    >
                      {/* <span className="sidebar-sub-toggle" style={ location.pathname === '/buyer' && { backgroundColor: 'rgba(69, 174, 180, 0.8)' }} > */}
                      <span className="sidebar-sub-toggle">
                        <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" /></svg>

                        <span className="font-size-14">Dashboard</span>{" "}
                      </span>
                      {/* </span> */}
                    </li>
                    {panel === 'seller' && (
                        <><li
                        onClick={() => {
                          navigate("/companydetail/"+uid+'/'+userLogin[0]?.cname);
                        }}
                        className=""
                      >
                        {/* <span className="sidebar-sub-toggle" style={ location.pathname === '/buyer' && { backgroundColor: 'rgba(69, 174, 180, 0.8)' }} > */}
                        <span className="sidebar-sub-toggle">
  <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 0 24 24" width="22px">
    <path d="M5 5V3h14v2h2v4h-1l-1 9H5l-1-9H3V5h2zm2 0h10V3H7v2zm11 2H6l1 9h10l1-9zm-5 4c-.83 0-1.5.67-1.5 1.5S12.17 15 13 15s1.5-.67 1.5-1.5S13.83 12 13 12z"/>
  </svg>
  <span className="font-size-14">Estore</span>
</span>

                        {/* </span> */}
                      </li>
                      <li
                        onClick={() => {
                          navigate("/analytics");
                        }}
                        className=""
                      >
                        {/* <span className="sidebar-sub-toggle" style={ location.pathname === '/buyer' && { backgroundColor: 'rgba(69, 174, 180, 0.8)' }} > */}
                        <span className="sidebar-sub-toggle">
                                  <i className="ti ti-comments"></i>
  <span className="font-size-14">Analytics</span>
</span>

                        {/* </span> */}
                      </li>
                      
                      </>
                    )}
                    {/* <li
                      onClick={() => {
                        navigate("/seller");
                      }}
                      className="my-3 mx-3"
                    >
                      <span className="sidebar-sub-toggle">
                        <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="#fff"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z" /></svg>

                        <span className="font-size-14">Dashboard</span>
                        </span>
                    </li> */}
                    {/* <a
                    href="/wallet"

                  >
                    <li style={{ color: "white", cursor: "pointer" }} className=" my-3 mx-3">
                      <span className="sidebar-sub-toggle">
                        <i className="ti-wallet"></i> E-wallet
                      </span>
                    </li>
                  </a> */}

{panel === 'seller' && (
                        <>

                  {userType != "" ?
                                        <>
                  {alert}
                                    {/* User Dropdown Start */}
                  <li
                    onClick={() => {
                      changeNavList(0, { "userDropdown": nav[0].userDropdown ? false : true });
                    }}
                  >
                    <Link className="sidebar-sub-toggle">
                      <div className="sidebar-items-content-container">
                        <div className="sidebar-sub-toggle-parent">
                          <i className="ti ti-user"></i>
                          <span className="font-size-14">User Profile</span>
                        </div>
                        <div className="sub-container-sidebar-items">
                          <span style={{ color: 'white' }} className="sidebar-collapse-icon ti-angle-down"></span>
                        </div>
                      </div>
                    </Link>
                  </li>

                  {nav[0].userDropdown === false ? (
                    <li className="sidebar-sub">
                      <Link to="/profile">
                        <li className="sidebar-sub-toggle">
                          <i className="ti ti-briefcase"></i>
                          <span className="font-size-14">Company Information</span>
                        </li>
                      </Link>
                      <Link to="/additional">
                        <li className="sidebar-sub-toggle">
                          <i className="ti ti-info"></i>
                          <span className="font-size-14">Business Information</span>
                        </li>
                      </Link>
                      <Link to="/companyimages">
                        <li className="sidebar-sub-toggle">
                          <i className="ti ti-image"></i>
                          <span className="font-size-14">Company Images</span>
                        </li>
                      </Link>
                      <Link to="/director">
                        <li className="sidebar-sub-toggle">
                          <i className="ti ti-user"></i>
                          <span className="font-size-14">Director Profile</span>
                        </li>
                      </Link>
                      <Link to="/catalog">
                        <li className="sidebar-sub-toggle">
                          <i className="ti ti-book"></i>
                          <span className="font-size-14">Catalogs</span>
                        </li>
                      </Link>
                    </li>
                  ) : null}
                  {/* User Dropdown End */}
                  </> : <></> }
                  </>
                      )}

                    {panel === 'seller' && userType == "" ?
                      <>
                        <hr style={{ color: "white", }} />
                        <Link to='/profile'>
                          <li
                            style={{
                              marginLeft: "15px",
                              marginTop: "26px",
                              color: "white",
                            }}
                          >
                            <i style={{ backgroundColor: "white", borderRadius: "50%", color: "black", textAlign: "center", fontWeight: "bolder", marginRight: "15px" }} class=" fa-circle-1">1</i>
                            {/* <i className="fa-solid fa-1"></i> */}
                            Profile
                          </li>
                        </Link>


                        <Link to='/additional'>
                          <li
                            style={{
                              marginLeft: "15px",
                              marginTop: "26px",
                              color: "white",
                            }}
                          >
                            <i style={{ backgroundColor: "white", borderRadius: "50%", color: "black", textAlign: "center", fontWeight: "bolder", marginRight: "15px" }} className="fa py-1 ">2</i> Business Profile
                          </li>

                        </Link>


                        <hr style={{ color: "white" }} />
                      </> :
                      <>
                        {/* <li
                        onClick={() => {


                          changeNavList(0, { "subscription": nav[0].subscription ? false : true })


                        }}
                      >
                        <a className="sidebar-sub-toggle">
                          <i className="fa fa-gift"></i> {" "}
                          <span className="sidebar-collapse-icon ti-angle-down"></span>
                        </a>
                      </li> */}
{panel === 'seller' && (
                        <>
                        <li
                          onClick={() => {
                            changeNavList(0, { "subscription": nav[0].subscription ? false : true })
                          }}
                        >
                          <Link

                            className="sidebar-sub-toggle">
                            <div className="sidebar-items-content-container">
                              <div className="sidebar-sub-toggle-parent">

                                <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px"><path d="M160-200h160v-320H160v320Zm240 0h160v-560H400v560Zm240 0h160v-240H640v240ZM80-120v-480h240v-240h320v320h240v400H80Z" /></svg>
                                <span className="font-size-14">Subscription </span>{" "}
                              </div>
                              <div className="sub-container-sidebar-items">
                                <span style={{ color: 'white' }} className="sidebar-collapse-icon ti-angle-down"></span>
                              </div>
                            </div>
                          </Link>
                        </li>


                        {/* <li> */}
                        {nav[0].subscription ? (
                          <li className="sidebar-sub">

                            <Link to="/subscription">
                              <li className="sidebar-sub-toggle">

                                <i className="fa fa-list"></i>
                                <span className="font-size-14">Packages Showcase</span>
                              </li>
                            </Link>

                            <Link to="/packages">
                              <li className="sidebar-sub-toggle">

                                <i className="ti-info-alt"></i>
                                <span className="font-size-14">Subscriptions</span>
                              </li>
                            </Link>

                          </li>

                        ) : (
                          <></>
                        )}
                        </>
                      )}

                        {/* {nav[0].subscription ? (
                          <>
                            <Link to="/subscription">
                              <li
                                style={{
                                  marginLeft: "23px",
                                  marginBottom: "6px",
                                  color: "white",
                                }}
                              >
                                <i className="fa fa-list"></i> Packages Showcase
                              </li>
                            </Link>
                            <Link to="/packages">
                              <li
                                style={{
                                  marginLeft: "23px",
                                  marginBottom: "6px",
                                  color: "white",
                                }}
                              >
                                <i className="ti-info-alt"></i> Subscriptions
                              </li>
                            </Link>
                          </>
                        ) : (
                          <></>
                        )} */}





                        {/* </li> */}

                        {panel === 'seller' && (
                        <>

                        {/* products List start*/}
                        <li
                          onClick={() => {
                            changeNavList(0, { "product": nav[0].product ? false : true })
                          }}
                        >
                          <Link

                            className="sidebar-sub-toggle">
                            <div className="sidebar-items-content-container">
                              <div className="sidebar-sub-toggle-parent">

                                <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px"><path d="M160-200h160v-320H160v320Zm240 0h160v-560H400v560Zm240 0h160v-240H640v240ZM80-120v-480h240v-240h320v320h240v400H80Z" /></svg>
                                <span className="font-size-14">Products </span>{" "}
                              </div>
                              <div className="sub-container-sidebar-items">
                                <span style={{ color: 'white' }} className="sidebar-collapse-icon ti-angle-down"></span>
                              </div>
                            </div>
                          </Link>
                        </li>
                        {/* <li
                          onClick={() => {

                            changeNavList(0, { "product": nav[0].product ? false : true })
                          }}
                        >
                          <a className="sidebar-sub-toggle">
                            <i className="fa-product-hunt fa"></i> Products
                            <span className="sidebar-collapse-icon ti-angle-down"></span>
                          </a>
                        </li> */}
                        <li>
                          {nav[0].product == false ? (
                            <li className="sidebar-sub">
                              <Link to="/productlist">
                                <li className="sidebar-sub-toggle">
                                  <i className="fa fa-list"></i>
                                  <span className="font-size-14">Product List</span>

                                </li>
                              </Link>
                              <Link to="/addproduct">
                                <li className="sidebar-sub-toggle">
                                  <i className="ti ti-plus"></i>
                                  <span className="font-size-14">Add Product</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                        </li>

                        {/* products List End*/}
                        </>
                      )}

                        {(panel === 'seller' || panel === 'buyer') && (
                        <>
                          {/* Manage Leads Start */}
                          <li
                            onClick={() => {
                              changeNavList(0, { "manageleads": nav[0].manageleads ? false : true });
                            }}
                          >
                            <Link className="sidebar-sub-toggle">
                              <div className="sidebar-items-content-container">
                                <div className="sidebar-sub-toggle-parent">
                                  <i className="ti ti-magnet"></i>
                                  <span className="font-size-14">Manage Leads</span>
                                </div>
                                <div className="sub-container-sidebar-items">
                                  <span
                                    style={{ color: 'white' }}
                                    className="sidebar-collapse-icon ti-angle-down"
                                  ></span>
                                </div>
                              </div>
                            </Link>
                          </li>

                          {nav[0].manageleads === false ? (
                            <li className="sidebar-sub">
                              <Link to={panel === "seller" ? "/buyleads" : "/product-buy-request"}>
                                <li className="sidebar-sub-toggle">
                                  <i className="ti ti-bookmark-alt"></i>
                                  <span className="font-size-14">General Buy Requests</span>
                                </li>
                              </Link>
                              {panel === 'seller' && (
                        <>
                              <Link to="/sendrequest">
                                <li className="sidebar-sub-toggle">
                                  <i className="ti ti-file"></i>
                                  <span className="font-size-14">Send Quote Requests</span>
                                </li>
                              </Link>
                              <Link to="/productlead">
                                <li className="sidebar-sub-toggle">
                                  <i className="ti ti-file"></i>
                                  <span className="font-size-14">Direct Requests</span>
                                </li>
                              </Link>
                              </>
                      )}
                            </li>
                          ) : null}
                          {/* Manage Leads End */}
                        </>
                      )}


{(panel === 'seller') && (
                        <>
                        {/* Khata Start */}

                        <li
                          onClick={() => {
                            changeNavList(0, { "khata": nav[0].khata ? false : true });
                          }}
                        >
                          <Link className="sidebar-sub-toggle">
                            <div className="sidebar-items-content-container">
                              <div className="sidebar-sub-toggle-parent">
                                <i className="ti ti-book"></i>
                                <span className="font-size-14">Khata</span>{" "}
                              </div>
                              <div className="sub-container-sidebar-items">
                                <span style={{ color: 'white' }} className="sidebar-collapse-icon ti-angle-down"></span>
                              </div>
                            </div>
                          </Link>
                        </li>

                        {/* { nav[0].khata ? (
                          <li className="sidebar-sub">

                          <Link to="/buyleads">

                            <li className="sidebar-sub-toggle">
                              <i className="ti ti-bookmark-alt"></i>
                              <span className="font-size-14">Product Buy Request</span>

                            </li>
                          </Link>
                          <Link to="/sendrequest">
                            <li className="sidebar-sub-toggle">
                              <i className="ti ti-file"></i>
                              <span className="font-size-14">Send Quote Request</span>
                            </li>
                          </Link>
                        </li> ):
                        } */}

                          {nav[0].khata === false? (
                            <li className="sidebar-sub">
                              <Link to="/khata-dashboard">
                               <li className="sidebar-sub-toggle">
                                  <i className="fa fa-home"></i>
                                  <span className="font-size-14">Dashboard</span>
                                </li>
                              </Link>
                              <Link to="/khata-ledger">
                               <li className="sidebar-sub-toggle">
                                  <i className="fa fa-list"></i>
                                  <span className="font-size-14">Ledger / Invoice</span>
                                </li>
                              </Link>
                              <Link to="/khataclient">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti ti-user"></i>
                                  <span className="font-size-14">Manage Clients</span>
                                </li>
                              </Link>
                              <Link to="/khatamanageinvoice">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti ti-notepad"></i> 
                                  <span className="font-size-14">Manage Invoices</span>
                                </li>
                              </Link>
                              <Link to="/khatadeliverychallan">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti ti-comments"></i>
                                  <span className="font-size-14">Delivery Challans</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                        {/* Khata End */}
                        </>
                      )}


{panel === 'seller' && (
                        <>
                        {/* Facebook Start */}

                        <li
                          onClick={() => {
                            changeNavList(0, { "facebook": nav[0].facebook ? false : true });
                          }}
                        >
                          <Link className="sidebar-sub-toggle">
                            <div className="sidebar-items-content-container">
                              <div className="sidebar-sub-toggle-parent">
                                <i className="fa fa-facebook"></i>
                                <span className="font-size-14">Facebook</span>{" "}
                              </div>
                              <div className="sub-container-sidebar-items">
                                <span style={{ color: 'white' }} className="sidebar-collapse-icon ti-angle-down"></span>
                              </div>
                            </div>
                          </Link>
                        </li>

                          {nav[0].facebook === false? (
                            <li className="sidebar-sub">
                              <Link to="/facebookIntegrationPage">
                               <li className="sidebar-sub-toggle">
                                  <i className="fa fa-connectdevelop"></i>
                                  <span className="font-size-14">Connect</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {nav[0].facebook === false? (
                            <li className="sidebar-sub">
                              <Link to="/facebookListing">
                               <li className="sidebar-sub-toggle">
                                  <i className="fa fa-bars"></i>
                                  <span className="font-size-14">Pages List</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {nav[0].facebook === false? (
                            <li className="sidebar-sub">
                              <Link to="/facebookPosting">
                               <li className="sidebar-sub-toggle">
                                  <i className="fa fa-clipboard"></i>
                                  <span className="font-size-14">Create a Post</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {nav[0].facebook === false? (
                            <li className="sidebar-sub">
                              <Link to="/facebookPostListing">
                               <li className="sidebar-sub-toggle">
                                  <i className="fa fa-list"></i>
                                  <span className="font-size-14">Posts List</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                        {/* facebook End */}
                        </>
                      )}
                      {(panel === 'seller' || panel === 'buyer') && (
                        <div style={{display:'none'}}>
                        <li
                          onClick={() => {
                            changeNavList(0, { "inventory": nav[0].inventory ? false : true });
                          }}>

                          <Link className="sidebar-sub-toggle">
                            <div className="sidebar-items-content-container">
                              <div className="sidebar-sub-toggle-parent">
                                <i className="ti-layout-grid4-alt"></i>
                                <span className="font-size-14">Inventory</span>{" "}
                              </div>
                              <div className="sub-container-sidebar-items">
                                <span style={{ color: 'white' }} className="sidebar-collapse-icon ti-angle-down"></span>
                              </div>
                            </div>
                          </Link>
                        </li>

                        {nav[0].inventory === false? (
                            <li className="sidebar-sub">
                              <Link to="/productdef">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti-info-alt"></i>
                                  <span className="font-size-14">Product Defination</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                        {nav[0].inventory === false? (
                            <li className="sidebar-sub">
                              <Link to="/productpricing">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti-info-alt"></i>
                                  <span className="font-size-14">Product Pricing</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {nav[0].inventory === false? (
                            <li className="sidebar-sub">
                              <Link to="/stocklevels">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti-info-alt"></i>
                                  <span className="font-size-14">Stock levels</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {nav[0].inventory === false? (
                            <li className="sidebar-sub">
                              <Link to="/productslist">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti-info-alt"></i>
                                  <span className="font-size-14">Product list</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {nav[0].inventory === false? (
                            <li className="sidebar-sub">
                              <Link to="/sales">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti-info-alt"></i>
                                  <span className="font-size-14">Sales & Returns</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {nav[0].inventory === false? (
                            <li className="sidebar-sub">
                              <Link to="/report">
                               <li className="sidebar-sub-toggle">
                                  <i className="ti-info-alt"></i>
                                  <span className="font-size-14">Reports</span>
                                </li>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
 </div>
                      )}

                        {/* <li>
                          {nav[0].inventory === false? (
                            <>

                              <Link to="/productdef">
                                <li
                                  style={{
                                    marginLeft: '23px',
                                    marginBottom: '6px',
                                    color: 'white',
                                  }}>
                                  <i className="ti-wallet"></i>Product Defination
                                </li>
                              </Link>
                              <Link to="/productpricing">
                                <li
                                  style={{
                                    marginLeft: '23px',
                                    marginBottom: '6px',
                                    color: 'white',
                                  }}>
                                  <i className="ti-info-alt"></i> Product Pricing
                                </li>
                              </Link>
                              <Link to="/stocklevels">
                                <li
                                  style={{
                                    marginLeft: '23px',
                                    marginBottom: '6px',
                                    color: 'white',
                                  }}>
                                  <i className="ti-info-alt"></i>Stock levels
                                </li>
                              </Link>
                              <Link to="/productslist">
                                <li
                                  style={{
                                    marginLeft: '23px',
                                    marginBottom: '6px',
                                    color: 'white',
                                  }}>
                                  <i className="ti-info-alt"></i>Product list
                                </li>
                              </Link>
                              <Link to="/sales">
                                <li
                                  style={{
                                    marginLeft: '23px',
                                    marginBottom: '6px',
                                    color: 'white',
                                  }}>
                                  <i className="ti-info-alt"></i>Sales & Returns
                                </li>
                              </Link>
                              <Link to="/report">
                                <li
                                  style={{
                                    marginLeft: '23px',
                                    marginBottom: '6px',
                                    color: 'white',
                                  }}>
                                  <i className="ti-info-alt"></i>Reports
                                </li>
                              </Link>
                            </>
                          ) : (
                            <></>
                          )}
                        </li> */}

                        {/* Office Management End Hidden #1122*/}
                        {/* Office Management End */}
                        {/* New Business start*/}
                        {/* New Business start Hidden #1122*/}

                        {/* <li
                    onClick={() => {
                      
                      changeNavList(0,{"newbusiness":nav[0].newbusiness?false:true})
                    }}
                  >
                    <a className="sidebar-sub-toggle">
                      <i className="ti-layout-grid4-alt"></i>New Business Ideas{" "}
                      <span className="sidebar-collapse-icon ti-angle-down"></span>
                    </a>
                  </li>
                  <li>
                    { nav[0].newbusiness ? (
                      <>
                        <Link to="">
                          <li
                            style={{
                              marginLeft: "23px",
                              marginBottom: "6px",
                              color: "white",
                            }}
                          >
                            <i className="ti-wallet"></i>New Business Ideas
                          </li>
                        </Link>
                        <Link to="">
                          <li
                            style={{
                              marginLeft: "23px",
                              marginBottom: "6px",
                              color: "white",
                            }}
                          >
                            <i className="ti-info-alt"></i> Pre Feasibility
                            Report
                          </li>
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}
                  </li> */}

                        {/* New Business End Hidden #1122*/}
                        {/* New Business End*/}


                        {/* Manual By Bazaid */}




                      </>

                   
}
                  </ul>
                  <div
                    className="sidebar-logout-div"
                    onClick={() => {
                      localStorage.removeItem("USER");
                      navigate("/login");
                    }}
                  >
                    <span style={{fontSize: '18px', fontWeight: 400}}>Sign Out</span>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="rgba(69, 174, 180, 0.8)"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z" /></svg>
                  </div>
                </SimpleBar>
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      {/* <div className="header">
        <div className="container-fluid">





          <div className={darw ? ["header-protected-screen", "mobile-table"].join(' ') : ["header-protected-screen-full-width", "mobile-table"].join(' ')}>
        <div
          onClick={() => {
            setDarw(!darw);
          }}
          style={{
            border: '1px solid rgb(79, 151, 161)',
            height: '40px',
            borderRadius: '50%',
            width: '37px',
            background: 'rgb(79, 151, 161)',
            zIndex: 999
          }}
        >
          <div 
          className="hamburger"
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
        <div className="protected-header">
          <div className="header-icon">

            <Link to="/buyer">
              <p
                style={{
                  paddingLeft: "11px",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  paddingRight: "11px",
                  backgroundColor: "#4F97A1",
                  border: "1px solid #4F97A1",
                  borderRadius: "20px",

                  color: "white",
                }}
                className="switch-seller-btn"
              >
                Switch to Buyer
              </p>
            </Link>
          </div>


          <div className="header-icon">

            <i style={{ color: "#4F97A1", fontWeight:800 }} className="ti-email"></i>
          </div>


          <div className="user-avatar">
            <svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 -960 960 960" fill="#4F97A1"><path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z"/></svg>
            <span className="user-avatar-name">{userLogin.length > 0 ? <>{userLogin[0].name}</> : <></>}</span>

          </div> */}


      <div
        style={{ padding: '1rem 3rem' }}
        className={darw ? ["header-protected-screen", "mobile-table"].join(' ') : ["header-protected-screen-full-width", "mobile-table"].join(' ')}>
        <div
          onClick={() => {
            setDarw(!darw);
          }}
          style={{
            border: '1px solid rgb(79, 151, 161)',
            height: '40px',
            borderRadius: '50%',
            width: '37px',
            background: 'rgb(79, 151, 161)',
          }}
          className=""
        >
          <div
            className="hamburger"
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
        {/* Hamburger */}
        {/* <div style={{display: 'flex',flex:1}}>

        </div> */}

        {/* className="float-right" */}
        <div className="protected-header">
          <div className="header-icon">
          
            <Link to={panel === 'seller' ? '/buyer' : '/seller'}>
              <p
                className="switch-seller-btn"
              >
                Switch to {panel === 'seller' ? 'Buyer' : 'Seller'}
              </p>
            </Link>
          </div>
          {/* <div className="dropdown dib"></div> */}

          <div className="header-icon">

            <Link to="/chat">
              <p
                className="switch-seller-btn"
              >
                <i style={{ color: "white", fontWeight: 800 }} className="ti-email"></i>
              </p>
            </Link>
          </div>
          <div className="header-icon">

            <Link to="/">
              <p
                className="switch-seller-btn"
              >
                <i style={{ color: "white", fontWeight: 800 }} className="ti-export"></i>
              </p>
            </Link>
          </div>


          {/* </a> */}


          {/* <div className="user-avatar">
            { <svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 -960 960 960" fill="#4F97A1"><path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z" /></svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 -960 960 960" fill="#d1d5db"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" /></svg>}
            <span className="user-avatar-name">{userLogin.length > 0 ? <>{userLogin[0].name}</> : <></>}</span>

          </div> */}


          {/* <div className="dropdown dib">
                  <div className="header-icon" data-toggle="dropdown">
                    <span className="user-avatar text-uppercase"></span>
                    <div className="drop-down dropdown-profile dropdown-menu dropdown-menu-right">
                      <div>
                        <ul>
                          <li>
                            <a href="#">
                              <i className="ti-user"></i>
                              <span>Personal Profile</span>
                            </a>
                          </li>

                          <li>
                            <a href="#">
                              <i className="ti-email"></i>
                              <span>Business Profile</span>
                            </a>
                          </li>

                          <li>
                            <a href="#">
                              <i className="ti-settings"></i>
                              <span>Director Profile</span>
                            </a>
                          </li>

                          <li>
                            <a href="/login">
                              <i className="ti-lock"></i>
                              <span>Certificate & Awards</span>
                            </a>
                          </li>
                          <li
                            onClick={() => {
                              localStorage.removeItem("USER");
                              navigate("/login");
                            }}
                          >
                            <a href="#">
                              <i className="ti-power-off"></i>
                              <span>Logout</span>
                            </a>
                          </li>

                          <li
                            onClick={() => {
                              alert("hi");
                              localStorage.removeItem("USER");
                              navigate("/login");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <a href="/login">
                              <i className="ti-close"></i> Logout
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> */}
          {/* </div>
            </div>
          </div> */}


          {/* <div className="dropdown dib">
                  <div className="header-icon" data-toggle="dropdown">
                    <span className="user-avatar text-uppercase"></span>
                    <div className="drop-down dropdown-profile dropdown-menu dropdown-menu-right">
                      <div>
                        <ul>
                          <li>
                            <a href="#">
                              <i className="ti-user"></i>
                              <span>Personal Profile</span>
                            </a>
                          </li>

                          <li>
                            <a href="#">
                              <i className="ti-email"></i>
                              <span>Business Profile</span>
                            </a>
                          </li>

                          <li>
                            <a href="#">
                              <i className="ti-settings"></i>
                              <span>Director Profile</span>
                            </a>
                          </li>

                          <li>
                            <a href="/login">
                              <i className="ti-lock"></i>
                              <span>Certificate & Awards</span>
                            </a>
                          </li>
                          <li
                            onClick={() => {
                              localStorage.removeItem("USER");
                              navigate("/login");
                            }}
                          >
                            <a href="#">
                              <i className="ti-power-off"></i>
                              <span>Logout</span>
                            </a>
                          </li>

                          <li
                            onClick={() => {
                              alert("hi");
                              localStorage.removeItem("USER");
                              navigate("/login");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <a href="/login">
                              <i className="ti-close"></i> Logout
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> */}
          {/* </div>
            </div>
          </div> */}
          {/* </div>
      </div> */}
          {/* <nav class="navbar navbar-expand-lg ">
            <div
              onClick={() => {
                setDarw(!darw);
              }}
              className=" float-left"
            >
              <div className="hamburger sidebar-toggle">
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
              </div>
            </div>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mr-auto">




              </ul>
              <div class="form-inline my-2 my-lg-0">
                <Link to="/buyer">
                  <button
                    className="btn btn-dark "
                    style={{


                      borderRadius: "20px",

                    }}
                  >
                    Switch to Buyer
                  </button>
                </Link>

                <a href="/chat">
                  <div className="header-icon mt-3">
                    <i style={{ color: "black" }} className="ti-email"></i>
                  </div>

                </a>

                <span
                  className="user-avatar text-uppercase mx-3 mt-3"
                // style={{ marginRight: "25px" }}
                >
                  {userLogin.length > 0 ? <>{userLogin[0].name}</> : <></>}
                </span>
                <div
                  style={{ marginTop: "8px" }}
                  className=" dropdown dib dropdown show "
                >
                  <a
                    className="btn btn-dark dropdown-toggle "
                    href="#"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i style={{ size: "100px" }} className="ti-user "></i>
                  </a>

                  <div
                    className="dropdown-menu drop-down dropdown-profile  dropdown-menu-right user-avatar"
                    aria-labelledby="dropdownMenuLink"
                  >
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate("/user");
                      }}
                      className="dropdown-item"
                    >
                      <i className="mx-2 ti-power-off"></i>User Profile {userType.role}
                    </a>

                    {userType == "seller" ?
                      <>
                        <div className="dropdown-divider"></div>

                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate("/profile");
                          }}
                          className="dropdown-item"
                        >
                          <i className="mx-2 ti-power-off"></i> Company Information
                        </a>
                        <div className="dropdown-divider"></div>


                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate("/additional");
                          }}
                          className="dropdown-item"
                        >
                          <i className="mx-2 ti-power-off"></i> Business Information
                        </a>
                        <div className="dropdown-divider"></div>



                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate("/companyimages");
                          }}
                          className="dropdown-item"
                        >
                          <i className="mx-2 ti-power-off"></i> Company Images
                        </a>
                        <div className="dropdown-divider"></div>

                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate("/director");
                          }}
                          className="dropdown-item"
                        >
                          <i className="mx-2 ti-power-off"></i> Director Profile
                        </a>
                        <div className="dropdown-divider"></div>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate("/catalog");
                          }}
                          className="dropdown-item"
                        >
                          <i className="mx-2 ti-power-off"></i> Catalogs
                        </a>
                        <div className="dropdown-divider"></div></> : <></>

                    }


                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        localStorage.removeItem("USER");
                        navigate("/login");
                      }}
                      className="dropdown-item"
                    >
                      <i className="mx-2 ti-power-off"></i> Log Out
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </nav> */}
          {/* Edit by b */}
        </div>
      </div>
    </>
  );
}

export default Nav;